// JS

import { initFacetWPAnimations } from './modules/modules.js';
import './modules/components.js';
// import './modules/functions';
// import './modules/typography';
import './modules/anim';
import './modules/layout.js';
import './modules/hero.js';
import './modules/navigation';
import './modules/blocks.js';
import './modules/modals.js';
import './modules/forms.js';
import './modules/swiper.js';
import ListingFilters from './modules/listing-filters.js';
import TeamModal from './modules/team-modal.js';
// import './modules/accessibility.js';

if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
}

// Initialize listing filters
ListingFilters.init();

// Initialize team modal
new TeamModal();

//
// Stylesheet
//
import '../sass/style.scss';
